<a-center-popup [title]="'Collection Settings'" (close)="onClosePopup()" class="collection_settings_popup">
    <edit-collection-form
      *ngIf="(collection$ | async) && (issetBoards$ | async)"
      [selectedBoards]="selectedBoards$ | async"
      [collection]="collection$ | async"
    ></edit-collection-form>
</a-center-popup>
